import React, { useContext, useEffect, useMemo, useState } from 'react';
import { SectionTitle } from 'components/SectionTitle';
import { DataContext } from 'Contexts/DataContext';
import { generateArticlesStyles } from 'sections/Articles/ArticlesStyles';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';
import { Card } from './Card';

// TODO: Remove this component

export function ArticlesMainPage({ title }: { title: string }) {
    const { data } = useContext(DataContext);
    const dataArticles = Object.values(data).flat();
    const allArticles = [...dataArticles].filter(a => a.category !== 'API');
    const [visibleCount, setVisibleCount] = useState(12); // Initially display 12 cards
    const [isFetching, setIsFetching] = useState(false);
    const theme = useTheme();
    const styles = useMemo(() => generateArticlesStyles(theme), [theme]);

    const handleScroll = () => {
        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 10 && !isFetching) {
            setIsFetching(true);
        }
    };

    useEffect(() => {
        if (!isFetching) return;

        const loadMoreArticles = () => {
            setVisibleCount((prevCount) => prevCount + 12);
            setIsFetching(false);
        };

        loadMoreArticles();
    }, [isFetching]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <Box component="section" sx={styles.wrapper}>
            <SectionTitle title={title} sx={styles.title} />

            <Box sx={styles.cards}>
                {allArticles.slice(0, visibleCount).map((article) => (
                    <Card key={article.title} {...article} />
                ))}
            </Box>

            {isFetching && <div>Loading more articles...</div>}
        </Box>
    );
}
